export class UserInterface {
}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/authentication/models/user.interface.ts